import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { IndexCard, Kontor } from '@store/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';

@Component({
    selector: 'app-impersonate-ui',
    templateUrl: './impersonate.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ImpersonateComponent implements OnChanges {

    form: UntypedFormGroup;
    @Input() users: IndexCard[];
    @Input() userId: Number;
    @Input() offices: Kontor[];
    @Input() officeId: number;
    @Input() officeName: string;
    @Output() getUsers = new EventEmitter<number>();
    @Output() impersonate = new EventEmitter<string>();

    constructor(
        private activeModal: NgbActiveModal,
        private fb: UntypedFormBuilder
    ) {
        this.createForm();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.valuesToForm();
        if (changes.officeId) {
            this.getUsers.emit(this.officeId);
        }
    }

    createForm() {
        this.form = this.fb.group({
            officeId: [-1],
            mid: [-1]
        });
    }

    valuesToForm() {
        if (this.userId && this.users && this.users.find(u => u.cardId === this.userId)) {
            this.form.controls['mid'].setValue(this.userId);
        }
        if (this.officeId) { this.form.controls['officeId'].setValue(this.officeId); }
    }

    onOfficeSelect(officeId: number) {
        this.form.controls['officeId'].setValue(officeId);
        this.form.controls['mid'].setValue(-1);
        this.officeId = officeId;
        this.getUsers.emit(officeId);
    }

    onDismiss() {
        this.activeModal.dismiss();
    }

    onOk(userId: number) {
        const ADuser = this.users.find(u => +u.cardId === +userId).brugerId;
        this.impersonate.emit(ADuser);
        this.activeModal.close();
    }
}
